(() => {
  const ROOT_SELECTOR = '[data-simonis-family-cards]';
  const CARD_SELECTOR = '[data-simonis-family-card]';
  const SIZE_OPTION_SELECTOR = '[data-simonis-size-option]';
  const SIZE_PANEL_SELECTOR = '[data-simonis-size-panel]';
  const CURRENT_PRICE_SELECTOR = '[data-simonis-price], [data-simonis-current-price]';
  const COLOR_OPTION_SELECTOR = '[data-cloth-color-option]';

  if (window.__simonisFamilySizeSelectorBound) return;
  window.__simonisFamilySizeSelectorBound = true;

  function escapeSelector(value) {
    if (window.CSS && typeof window.CSS.escape === 'function') return window.CSS.escape(value);
    return String(value).replace(/"/g, '\\"');
  }

  function getCard(target) {
    return target instanceof Element ? target.closest(CARD_SELECTOR) : null;
  }

  function getActivePanel(card) {
    return card ? card.querySelector(`${SIZE_PANEL_SELECTOR}.is-active`) : null;
  }

  function getPanel(card, sizeKey) {
    return card ? card.querySelector(`${SIZE_PANEL_SELECTOR}[data-size-key="${escapeSelector(sizeKey)}"]`) : null;
  }

  function setButtonState(card, sizeKey) {
    card.querySelectorAll(SIZE_OPTION_SELECTOR).forEach((button) => {
      const selected = button.dataset.sizeKey === sizeKey;
      button.classList.toggle('is-active', selected);
      button.setAttribute('aria-selected', selected ? 'true' : 'false');
    });
  }

  function initializeColorPanel(panel, preferredColor) {
    if (!panel) return;

    let option = null;
    if (preferredColor) {
      option = Array.from(panel.querySelectorAll(COLOR_OPTION_SELECTOR)).find((item) => item.dataset.colorName === preferredColor) || null;
    }
    option = option || panel.querySelector(`${COLOR_OPTION_SELECTOR}.is-active`) || panel.querySelector(COLOR_OPTION_SELECTOR);

    if (option && window.BCClothCardVersion4 && typeof window.BCClothCardVersion4.selectOption === 'function') {
      window.BCClothCardVersion4.selectOption(option);
    } else if (option) {
      panel.querySelectorAll(COLOR_OPTION_SELECTOR).forEach((item) => {
        const selected = item === option;
        item.classList.toggle('is-active', selected);
        item.setAttribute('aria-selected', selected ? 'true' : 'false');
      });
      const image = panel.querySelector('[data-cloth-main-image]');
      const label = panel.querySelector('[data-cloth-selected-color]');
      if (image && option.dataset.imageSrc) {
        image.src = option.dataset.imageSrc;
        if (option.dataset.imageSrcset) image.srcset = option.dataset.imageSrcset;
        image.alt = option.dataset.imageAlt || option.dataset.colorName || '';
      }
      if (label) label.textContent = option.dataset.colorName || '';
    }
  }

  function selectSize(card, sizeKey) {
    if (!card || !sizeKey) return;

    const currentPanel = getActivePanel(card);
    const preferredColor = currentPanel?.querySelector(`${COLOR_OPTION_SELECTOR}.is-active`)?.dataset.colorName || '';
    const nextPanel = getPanel(card, sizeKey);
    if (!nextPanel || nextPanel === currentPanel) return;

    card.querySelectorAll(SIZE_PANEL_SELECTOR).forEach((panel) => {
      const active = panel === nextPanel;
      panel.classList.toggle('is-active', active);
      panel.hidden = !active;
    });

    setButtonState(card, sizeKey);

    const currentPrice = card.querySelector(CURRENT_PRICE_SELECTOR);
    const nextPrice = nextPanel.dataset.priceDisplay || nextPanel.dataset.price || '';
    // Never blank the price: a panel with no price data must leave the
    // previous figure standing rather than empty the line.
    if (window.BCHoverPreview) window.BCHoverPreview.setText(currentPrice, nextPrice);
    else if (currentPrice && nextPrice) currentPrice.textContent = nextPrice;

    initializeColorPanel(nextPanel, preferredColor);
    // A pointerout still to come would otherwise restore the pre-click price.
    previewedPrice.delete(card);
    card.dispatchEvent(new CustomEvent('simonis:sizechange', { bubbles: true, detail: { sizeKey } }));
  }

  /*
   * Hover/focus price preview for the size buttons: pointing at a size shows
   * that size's price in the card header and leaving puts back whatever was
   * there before. The previous text is remembered rather than recomputed,
   * because on the cue-tip cards the header also carries the price of the
   * selected swatch - recomputing from the panel would quietly discard the
   * customer's swatch choice. The active size is skipped: its price is
   * already the one on display.
   */
  const previewedPrice = new WeakMap();

  function headerPrice(card) {
    return card ? card.querySelector(CURRENT_PRICE_SELECTOR) : null;
  }

  // Shared hover mechanics - the group-wide leave rule, hover/focus-visible
  // gating, the never-empty price write. See assets/bc-hover-preview.js.
  const HP = window.BCHoverPreview;

  function previewSize(option) {
    const card = getCard(option);
    if (!card || option.classList.contains('is-active')) return;
    const panel = getPanel(card, option.dataset.sizeKey);
    const priceEl = headerPrice(card);
    if (!panel || !priceEl) return;
    const next = panel.dataset.priceDisplay || panel.dataset.price || '';
    if (!next) return;
    // The base is captured once per card, on the first preview, so it is
    // always the SELECTED price and never another preview's value.
    if (!previewedPrice.has(card)) previewedPrice.set(card, priceEl.textContent);
    if (HP) HP.setText(priceEl, next);
    else priceEl.textContent = next;
  }

  // Takes the card directly rather than an option: the pointer may well be
  // leaving from a swatch or from the photo, not from a size button.
  function restoreSizeCard(card) {
    const priceEl = headerPrice(card);
    if (!card || !priceEl || !previewedPrice.has(card)) return;
    const base = previewedPrice.get(card);
    previewedPrice.delete(card);
    if (HP) HP.setText(priceEl, base);
    else priceEl.textContent = base;
  }

  function cardOf(node) {
    if (!(node instanceof Element)) return null;
    return (HP ? HP.group(node) : null) || node.closest(CARD_SELECTOR);
  }

  document.addEventListener('pointerover', (event) => {
    if (HP && !HP.hoverCapable()) return;
    const option = event.target.closest?.(SIZE_OPTION_SELECTOR);
    if (!option) return;
    previewSize(option);
  });

  // Was: restore on leaving any single size button - which fired between two
  // adjacent buttons, before the next one's pointerover, and bounced the
  // price through the base value on every step of a sweep (measured: four
  // bounces across the six Simonis 860 buttons). Then it was held for the
  // whole card, which kept a hovered size's price up on the way to BUY. Now
  // it is the size rail's own pointerleave, served by bc-hover-preview.js
  // for every row: sliding along the buttons is one swap per button, the
  // gaps between them are the rail's own box, and leaving the rail puts
  // the chosen size's price back.
  if (HP) {
    HP.onZoneLeave('[data-simonis-size-rail]', (zone) => {
      const card = cardOf(zone);
      if (!card || !previewedPrice.has(card)) return;
      restoreSizeCard(card);
    });
  }

  document.addEventListener('focusin', (event) => {
    const option = event.target.closest?.(SIZE_OPTION_SELECTOR);
    if (!option) return;
    if (HP && !HP.focusVisible(option)) return;
    previewSize(option);
  });

  document.addEventListener('focusout', (event) => {
    if (!(event.target instanceof Element)) return;
    const option = event.target.closest?.(SIZE_OPTION_SELECTOR);
    if (!option) return;
    if (HP && !HP.focusVisible(option)) return;

    const card = cardOf(event.target);
    if (!card || !previewedPrice.has(card)) return;
    if (HP && !HP.leavesGroup(event.target, event.relatedTarget)) return;

    restoreSizeCard(card);
  });


  function initialize(root = document) {
    root.querySelectorAll(`${ROOT_SELECTOR} ${CARD_SELECTOR}`).forEach((card) => {
      if (card.dataset.simonisSizeSelectorInitialized === 'true') return;
      card.dataset.simonisSizeSelectorInitialized = 'true';
      const activePanel = getActivePanel(card) || card.querySelector(SIZE_PANEL_SELECTOR);
      if (activePanel) {
        activePanel.hidden = false;
        activePanel.classList.add('is-active');
        initializeColorPanel(activePanel, '');
        const sizeKey = activePanel.dataset.sizeKey;
        if (sizeKey) setButtonState(card, sizeKey);
      }
    });
  }

  document.addEventListener('click', (event) => {
    const sizeOption = event.target.closest(SIZE_OPTION_SELECTOR);
    if (!sizeOption) return;
    selectSize(getCard(sizeOption), sizeOption.dataset.sizeKey);
  });

  document.addEventListener('keydown', (event) => {
    const option = event.target.closest(SIZE_OPTION_SELECTOR);
    if (!option || (event.key !== 'Enter' && event.key !== ' ')) return;
    event.preventDefault();
    selectSize(getCard(option), option.dataset.sizeKey);
  });

  document.addEventListener('DOMContentLoaded', () => initialize(document));
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));

  window.BCSimonisFamilySizeSelector = { initialize, selectSize };

  if (document.readyState !== 'loading') initialize(document);
})();
